import { FC, Fragment, createElement } from 'react';
import { AppsflyerListener } from './appsflyer-listener';
import { ErrorBoundary } from 'packages/react-error-boundary';
import { AppsflyerPlugin } from 'packages/appsflyer-plugin/api';
import { AcquireNewCustomerType } from '../acquire-new-customer';

interface AppsflyerProps {
  appsflyerPlugin: AppsflyerPlugin;
  AcquireNewCustomer?: AcquireNewCustomerType;
}

const DeepLink: FC<AppsflyerProps> = ({ appsflyerPlugin }) => (
  <AppsflyerListener appsflyerPlugin={appsflyerPlugin}>
    {() => null}
  </AppsflyerListener>
);

const DeepLinkForAcquisition: FC<Required<AppsflyerProps>> = ({
  appsflyerPlugin,
  AcquireNewCustomer
}) => (
  <AppsflyerListener appsflyerPlugin={appsflyerPlugin}>
    {(props) =>
      props.isAcquisition ? (
        <AcquireNewCustomer pageName="" acquisitionOptions={props.options}>
          {(acquisitionUrlAnchor) => {
            acquisitionUrlAnchor.onClick();
            return <Fragment />;
          }}
        </AcquireNewCustomer>
      ) : null
    }
  </AppsflyerListener>
);

export const AppsFlyerManager: FC<AppsflyerProps> = ({
  appsflyerPlugin,
  AcquireNewCustomer
}) => (
  <ErrorBoundary
    renderError={() => {
      window.console.warn(
        'Appsflyer: Error occurred while handling deep link data'
      );
      return null;
    }}
  >
    {AcquireNewCustomer ? (
      <DeepLinkForAcquisition
        appsflyerPlugin={appsflyerPlugin}
        AcquireNewCustomer={AcquireNewCustomer}
      />
    ) : (
      <DeepLink appsflyerPlugin={appsflyerPlugin} />
    )}
  </ErrorBoundary>
);
